import React from 'react';
import { CheckCircle, Ban, Bell, Truck, Trash2, X } from 'lucide-react';

const VARIANT_STYLES = {
  success: { container: 'border-emerald-200 bg-emerald-50 ring-emerald-900/5', icon: CheckCircle, iconWrap: 'bg-emerald-100 text-emerald-700', title: 'text-emerald-900', subtitle: 'text-emerald-700' },
  info:    { container: 'border-indigo-200 bg-indigo-50 ring-indigo-900/5', icon: Truck, iconWrap: 'bg-indigo-100 text-indigo-700', title: 'text-indigo-900', subtitle: 'text-indigo-700' },
  warning: { container: 'border-orange-200 bg-orange-50 ring-orange-900/5', icon: Bell, iconWrap: 'bg-orange-100 text-orange-700', title: 'text-orange-900', subtitle: 'text-orange-700' },
  error:   { container: 'border-red-200 bg-red-50 ring-red-900/5', icon: Ban, iconWrap: 'bg-red-100 text-red-700', title: 'text-red-900', subtitle: 'text-red-700' },
  neutral: { container: 'border-slate-200 bg-white ring-slate-900/5', icon: Trash2, iconWrap: 'bg-slate-100 text-slate-700', title: 'text-slate-900', subtitle: 'text-slate-500' },
};

export function Toast({ id, variant = 'info', title, subtitle, onClose }) {
  const style = VARIANT_STYLES[variant] || VARIANT_STYLES.info;
  const Icon = style.icon;
  const isError = variant === 'error';
  return (
    <div
      role={isError ? 'alert' : 'status'}
      aria-live={isError ? 'assertive' : 'polite'}
      aria-atomic="true"
      data-testid={`toast-${id}`}
      className={`pointer-events-auto w-full max-w-md animate-fade-in-up rounded-2xl border p-4 shadow-xl ring-1 ${style.container}`}
    >
      <div className="flex gap-3">
        <div className={`flex h-10 w-10 flex-shrink-0 items-center justify-center rounded-xl ${style.iconWrap}`}>
          <Icon className="h-5 w-5" aria-hidden />
        </div>
        <div className="min-w-0 flex-1 pt-0.5">
          <p className={`text-sm font-bold ${style.title}`}>{title}</p>
          {subtitle ? (
            <p className={`mt-1 line-clamp-2 text-xs font-medium ${style.subtitle}`}>{subtitle}</p>
          ) : null}
        </div>
        <button
          type="button"
          onClick={onClose}
          className="-m-1 flex-shrink-0 rounded-lg p-2 text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-700"
          aria-label="Fechar aviso"
        >
          <X className="h-5 w-5" />
        </button>
      </div>
    </div>
  );
}
